import React from 'react';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { CompanyRole, CompanyRoleAssignment } from '../../../../../types/company_role_assignment/companyRoleAssignment';
import { CompanyRoleAssignmentUtil } from '../../../../../types/company_role_assignment';

export default function CompanyRoleAssignmentFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<CompanyRoleAssignment>) {
  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.role || [])]}
      text={item => CompanyRoleAssignmentUtil.roleToString(item as CompanyRole)}
      onRemove={i => {
        filterProps.role?.delete(i);
        if (!filterProps.role?.size) filterProps.role = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
